
define('text!templates/app/supervisor/setting.html',[],function () { return 'used in views/app/supervisor/setting/setting.js\n';});

